import React from 'react';
import { ClientsPanelHeader, CustomInput, ValidationErrorText } from '../../../common/custom';
import CircularILoader from '../../../common/custom/circularLoader';
import CustomContainer from '../../../common/custom/CustomContainer';
import FilePreview from '../../../common/custom/file-preview/file-preview';
import FileUpload from '../../../common/custom/file-upload/file-upload.component';
import { FILE_TYPE } from '../../../helpers/helpers';
import { useLeaseProtectionListing } from './useAddLeaseProtection';

const AddLeaseProtection = () => {

  const {
    navigate,
    isImageLoading,
    isContractLoading,
    contractAttachments,
    handleContractAttachments,
    handleContractAttachmentCancel,
    onSubmitTrigger,
    leaseProtectionFiles,
    createLeadLoading,
    customerName,
    handleLeaseProtectionFiles,
    handleLeaseProtectionCancel,
    saveLeaseProtection,
    setCustomerName,
    leaseNo,
    setLeaseNo
  } = useLeaseProtectionListing();

  const loadingSvg = (<svg className="animate-spin h-5 w-5 mr-2 inline-block text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
  </svg>);

  return (
    <CustomContainer>
      <ClientsPanelHeader />
      <div className='pt-4 h-full flex items-center justify-center'>
        <div className='shadow-[0px_1px_9px_0px_#0000001C] bg-white rounded-xl p-[40px] w-full max-w-[895px]'>
          <p className='text-[26px] font-semibold text-[#77553D] mb-2'>
            Lease Protection Policy
          </p>
          <div className='pt-4'>
            <CustomInput
              name='customerName'
              placeholder='Enter customer name'
              required
              type='text'
              label='Customer Name'
              onChange={(e) => setCustomerName(e.target.value)}
            />
            {(onSubmitTrigger && (!customerName || customerName === "" || customerName === undefined)) && <div className='mt-2 mb-2'>
              <ValidationErrorText>Customer Name is required</ValidationErrorText>
            </div>}
          </div>
          <div className='pt-4'>
            <CustomInput
              name='leaseNo'
              placeholder='Enter lease no'
              required
              type='text'
              label='Lease No'
              onChange={(e) => setLeaseNo(e.target.value)}
            />
            {(onSubmitTrigger && (!leaseNo || leaseNo === "" || leaseNo === undefined)) && <div className='mt-2 mb-2'>
              <ValidationErrorText>Lease number is required</ValidationErrorText>
            </div>}
          </div>
          <div className='pt-4'>
            <div className='mb-4'>
              Upload Images
            </div>
            <div className='mb-2'>
              {leaseProtectionFiles && isImageLoading ? (
                <div className='flex h-[126px] justify-center items-center gap-1 self-stretch border px-6 py-4 rounded-xl border-dashed border-[#B8BABE]'>
                  <CircularILoader />
                </div>
              ) : leaseProtectionFiles?.length > 0 ? (
                <FilePreview
                  files={leaseProtectionFiles}
                  handleCancel={handleLeaseProtectionCancel}
                />
              ) : ""}
            </div>
            <FileUpload
              handleChange={handleLeaseProtectionFiles}
              fileTypes={FILE_TYPE}
              multiple={true}
            />
          </div>
          <div className='pt-4'>
            <div className='mb-4'>
              Contract Attachments
            </div>
            <div className='mb-2'>
              {contractAttachments && isContractLoading ? (
                <div className='flex h-[126px] justify-center items-center gap-1 self-stretch border px-6 py-4 rounded-xl border-dashed border-[#B8BABE]'>
                  <CircularILoader />
                </div>
              ) : contractAttachments?.length > 0 ? (
                <FilePreview
                  files={contractAttachments}
                  handleCancel={handleContractAttachmentCancel}
                />
              ) : ""}
            </div>
            <FileUpload
              handleChange={handleContractAttachments}
              fileTypes={FILE_TYPE}
              multiple={true}
            />
          </div>
          <div className='flex items-center justify-end gap-6 pt-8'>
            <button
              className='border border-[#77553D] text-[#77553D] py-2 px-10  rounded-lg'
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              type='submit'
              onClick={saveLeaseProtection}
              className='border border-[#77553D] bg-[#77553D] text-white py-2 px-8 rounded-lg'
              disabled={createLeadLoading}
            >
              {createLeadLoading ? (
                <span>
                  {loadingSvg}
                  Loading...
                </span>
              ) : "Save"}
            </button>
          </div>
        </div>
      </div>
    </CustomContainer>
  )
}

export default AddLeaseProtection 